import webView from 'common/webView';

const isInWebView = () => webView.isInWebView;

export default isInWebView;
